/**
 * Document-native rendering dispatcher.
 *
 * Segments the assistant's markdown into typed render blocks and
 * routes each to the renderer responsible for that structural intent.
 * Tables route to AnswerTable; everything else falls through to
 * MarkdownView (prose + code + lists + headings + quotes).
 *
 * Streaming-safe: re-segments on every source change. Partial tables
 * remain prose blocks until the header/separator/row triplet completes.
 */
import { type Component, For, Match, Switch, createMemo } from "solid-js";

import MarkdownView from "../MarkdownView";
import AnswerTable from "./AnswerTable";
import { segmentBlocks } from "./segment";

interface Props {
  source: string;
}

const StructuralRenderer: Component<Props> = (props) => {
  const blocks = createMemo(() => segmentBlocks(props.source));

  return (
    <For each={blocks()}>
      {(block) => (
        <Switch fallback={<MarkdownView source={block.raw} />}>
          <Match when={block.intent === "table"}>
            <AnswerTable source={block.raw} />
          </Match>
        </Switch>
      )}
    </For>
  );
};

export default StructuralRenderer;
